import { BooleanField, BooleanFieldProps, useRecordContext } from "react-admin";

const CustomBooleanField = (props: BooleanFieldProps) => {
  const record = useRecordContext();
  const source = props.source as string;
  return <BooleanField sx={{ color: record && record[source] ? "green" : "red" }} {...props} />;
};

export default CustomBooleanField;
